import { useNavigate } from 'react-router-dom';
import { Button, Card, ErrorBanner, Spinner } from '../components/ui';
import { useWars } from '../hooks/useFramework';

export function Landing() {
  const navigate = useNavigate();
  const wars = useWars();

  if (wars.isPending) return <Spinner label="Loading reviews…" />;
  if (wars.isError || !wars.data) return <ErrorBanner message="Couldn’t load the available reviews. Please retry." />;
  const available = wars.data;

  return (
    <div className="space-y-8">
      <div className="max-w-2xl">
        <h1 className="text-4xl font-medium text-climb-paper">Self-Assessments</h1>
        <p className="mt-4 text-lg text-climb-teal-soft">
          Self-assess against a structured framework. Answer at your own pace. At the end, enter your
          details to get your maturity report and recommendations.
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        {available.map((war, i) => (
          <Card
            key={war.focus}
            className={`flex flex-col gap-3 border-l-4 ${
              ['border-l-climb-coral', 'border-l-climb-cyan', 'border-l-climb-sage'][i % 3]
            }`}
          >
            <h2 className="text-xl font-medium text-climb-paper">{war.title}</h2>
            <p className="flex-1 text-sm text-climb-teal-soft">{war.tagline}</p>
            <Button onClick={() => navigate(`/${war.focus}`)} className="self-start">
              Start this review
            </Button>
          </Card>
        ))}
      </div>
    </div>
  );
}
